import { useQuery } from "@tanstack/react-query";
import fetchToBackend, { buildQuery } from "@/utils/fetchToBackend";
import { adminKeys } from "@/lib/query-keys";
import type { ContractingMissingPriceRelationReport } from "@/types/domain";
import type { ContractingErrorFilters } from "./useAdminContractingErrors";

export interface ContractingMissingFilesFilters extends ContractingErrorFilters {
  onlyDiscarded?: boolean;
}

/** Obras sin relación de precios: en cola del scraper o descartadas (panel admin). */
export function useAdminMissingFiles(
  filters: ContractingMissingFilesFilters = {},
) {
  return useQuery({
    queryKey: adminKeys.contractingMissingFiles(filters),
    queryFn: async () => {
      const query = buildQuery({
        stages: filters.stages,
        publicatedFrom: filters.publicatedFrom,
        publicatedTo: filters.publicatedTo,
        sortBy: filters.sortBy,
        onlyDiscarded: filters.onlyDiscarded ? "true" : undefined,
      });
      const res = await fetchToBackend<any>(
        `/admin/contractings-missing-files${query}`,
      );
      return (res?.data ??
        res ??
        []) as ContractingMissingPriceRelationReport[];
    },
  });
}
